import { Navigate, Outlet, useLocation } from "react-router-dom";
import SecureStorage from "../../utils/secureStorage";

/**
 * ProtectedRoute
 *
 * Guards routes from unauthenticated access.
 * - Validates token existence AND expiry (client-side JWT decode)
 * - Passes `from` state so LoginPage can redirect back after login
 * - If adminOnly prop is true, also checks role === 'admin'
 */
const ProtectedRoute = ({ adminOnly = false }) => {
  const location = useLocation();

  const token = SecureStorage.getToken(adminOnly);

  // No token, or token exists but is expired
  if (!token) {
    return (
      <Navigate
        to={adminOnly ? "/admin/login" : "/login"}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  // For admin routes, verify the role claim in the JWT
  if (adminOnly) {
    const role = SecureStorage.getRole(true);
    if (role !== "admin") {
      return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
